export default __webpack_public_path__ + "static/media/toiletten.d031c927.svg";